import axios from "axios";
import { setJWTToken } from "../Api.ts";
import { store } from "../../Redux/Store"
import { ChangeCheckedTutorial, SignIn } from "../../Redux/Actions"
import i18n from "../../Config/i18n.js";
import { requestUser } from "../../Services/userServices/request.ts";

let url = "https://auth.biosolvit.com/api";
try {
    url = process.env.REACT_APP_SSO_URL ? process.env.REACT_APP_SSO_URL : "https://auth.biosolvit.com/api";
} catch (error) {
    url = "https://auth.biosolvit.com/api";
}

const api = axios.create({
    baseURL: url,
    
    timeout: 30000,
    headers: {'Accept': 'application/json', "Content-Type": "application/json"},
})
api.defaults.withCredentials = true;
try {
    api.defaults.headers['X-Client-key'] = process.env.REACT_APP_CLIENT_KEY ? process.env.REACT_APP_CLIENT_KEY : "7k5jh32235jhbnrr18bco0pgpj";
} catch (error) {
    api.defaults.headers['X-Client-key'] = "7k5jh32235jhbnrr18bco0pgpj"
}

export class AuthService {
    /**
     * Faz a verificação de login
     * @param {string} userEntry usuário
     * @param {string} passwordEntry senha
     * @param {string} captcha captcha
     * @param {string} device dispositivo
     * @returns {Object} usuário
     */
    async SignIn(userEntry : string, passwordEntry : string, captcha : string, device: string): Promise<any>{
        try{
            const response = await api.post('/loginFront', {
                'g-repatcha': captcha,
                'device_name': device,
                'username': userEntry,
                'password': passwordEntry
            }, {
                headers: {
                    'Authorization': `Basic ${btoa(`${userEntry}:${passwordEntry}`)}`,
                }
            });
            setJWTToken(response.data.access_token);
            return response.data;
        }catch(error: any){
            if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
        
    }

    /**
     * Faz a requisição para atualizar o token de login
     * @returns {Object} usuário
     */
    async refreshLogin(): Promise<any> {
        try{
            const response = await api.get('/v1/me');
            setJWTToken(response.data.access_token);
            const newUser = await requestUser.getCurrentUser();
            store.dispatch(SignIn({...newUser, access_token: response.data.access_token}));
            store.dispatch(ChangeCheckedTutorial(newUser.user.checkedTutorial));
        }catch(error: Error | any){
            this.refreshToken()
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Faz a requisição para atualizar o token de login
     * @returns {Object} usuário
     */
    async refreshToken(): Promise<any> {
        try{
            const refreshToken = JSON.parse(localStorage.getItem("user") || '{}');
            const response = await api.post('/refreshToken', {
                "user_id": refreshToken.user.cognito_id,
                "refresh_token": refreshToken.refresh_token
            });
            setJWTToken(response.data.access_token);
            const newUser = await requestUser.getCurrentUser();
            store.dispatch(SignIn({...newUser, access_token: response.data.access_token}));
            store.dispatch(ChangeCheckedTutorial(newUser.user.checkedTutorial));
        }catch(error: Error | any){
            console.error("Error refreshing token:", error);
            // throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Faz o Logout do usuário
     */
    async SignOut(): Promise<void> {
        try{
            const response = await api.get('/v1/logout');
            api.defaults.headers.common['Authorization'] = null;

            return response.data;
        }catch(error){
            api.defaults.headers.common['Authorization'] = null;
            return ;
        }
        
    }

    async ForgetPassWrod(email: string,  captcha: string): Promise<void> {
        try{
            const response = await api.post('/forgotPassword', {'email': email, 'g-repatcha': captcha});

            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw new Error("Unauthenticated");
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async ForgetPassWrodSubmit(token: string, senha:string, confirmsenha: string): Promise<void> {
        try{
            const response = await api.post('/forgotPasswordSubmit', {
                'token': token,
                'senha': senha,
                'confirmarsenha': confirmsenha
            });

            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw new Error("Unauthenticated");
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
        
    }
}

export const authService = new AuthService();